import { API_BASE_URL, HAS_API_URL } from '../config/api';

/**
 * @param {import('firebase/auth').User} user
 * @param {string} packKey
 * @returns {{ ok: true, url: string } | { ok: false, error: string }}
 */
export async function requestPolarCheckout(user, packKey) {
  if (!user) {
    return { ok: false, error: 'Please sign in to purchase credits.' };
  }
  if (!HAS_API_URL) {
    return {
      ok: false,
      error:
        'The app is not configured to reach the payment server. Please contact support.',
    };
  }

  try {
    const idToken = await user.getIdToken();
    const res = await fetch(`${API_BASE_URL}/api/polar/create-checkout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ pack: packKey }),
    });

    if (res.ok) {
      let body = null;
      try {
        body = await res.json();
      } catch {
        /* ignore */
      }
      const url = typeof body?.url === 'string' ? body.url : '';
      if (url) {
        return { ok: true, url };
      }
      return { ok: false, error: 'Checkout response was incomplete. Please try again.' };
    }

    let serverMsg = '';
    try {
      const ct = res.headers.get('Content-Type') || '';
      if (ct.includes('application/json')) {
        const j = await res.json();
        serverMsg = typeof j?.error === 'string' ? j.error : '';
      }
    } catch {
      /* ignore */
    }

    switch (res.status) {
      case 401:
        return {
          ok: false,
          error: 'Your session could not be verified. Please sign out and sign in again.',
        };
      case 400:
        return { ok: false, error: serverMsg || 'Invalid request. Please try again.' };
      default:
        return {
          ok: false,
          error: serverMsg || 'Could not start checkout. Please try again.',
        };
    }
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    const likelyCors =
      typeof message === 'string' &&
      (message.includes('Failed to fetch') || message.includes('NetworkError'));
    if (likelyCors) {
      console.error('[polar-checkout] fetch failed (possible CORS)', message);
    }
    return {
      ok: false,
      error:
        process.env.NODE_ENV === 'development' && message
          ? `Could not reach the server. (${message})`
          : 'Could not reach the server. Check your connection and try again.',
    };
  }
}
